<template>
    <el-form :inline="true" :model="queryParam" class="mainSearch">
      <el-form-item label="标题">
        <el-input v-model="queryParam.title" placeholder="输入标题" />
      </el-form-item>
      <el-form-item label="类型">
          <el-select
            style="width:100%"
            v-model="queryParam.btype"
            clearable
            placeholder="请选择类型"
          >
            <el-option
              v-for="item in bannerTypeData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="queryParam.status" placeholder="横幅状态" style="width:120px">
          <el-option label="正常" :value="1" />
          <el-option label="停用" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getListBanner">查询</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-form-item>
    </el-form>
    <el-row>
      <el-col :span="24">
        <div class="mainTableTop">
          <el-button
            type="primary"
            @click="(dialog = true), doBannerAdd()"
            v-hasPermission="['banner:add']"
            >上传横幅</el-button>
        </div>
      </el-col>
    </el-row>
  
    <el-row class="mainTableBox">
      <el-col :span="24" class="mpadding">
        <el-table ref="tableRef" v-loading="loadingData" :data="tableData" class="mainTable">
          <el-table-column prop="title" label="标题"/>
          <el-table-column prop="btype" label="类型"/>
          <el-table-column prop="page" label="页面"/>
          <!-- <el-table-column prop="weight" label="排序"/> -->
          <el-table-column prop="created" label="创建时间">
            <template #default="scope">
              <span
                v-text="
                  util.formatDateUnix(scope.row.created, 'yyyy-MM-dd hh:mm')
                "
              ></span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" >
            <template #default="scope">
              <el-tag
                round
                :type="scope.row.status === 1 ? 'success' : 'danger'"
                disable-transitions
                ><span v-text="util.showCommonStatus(scope.row.status)"></span>
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="160">
            <template #default="scope">
              <el-link
              type="primary"
              @click="(dialog = true), doBannerEdit(scope.$index, scope.row)"
              v-hasPermission="['banner:edit']"
              >编辑</el-link>
  
              <el-popconfirm
                confirm-button-type="primary"
                confirm-button-text="确定"
                cancel-button-text="取消"
                icon-color="#626AEF"
                title="您确定删除吗？"
                width="200px"
                @confirm="doBannerDelete(scope.$index, scope.row)"
              >
                <template #reference>
                  <el-link
                    type="danger"
                    v-hasPermission="['banner:delete']"
                    >删除</el-link
                  >
                </template>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  
    <el-row class="mainTableBottom">
      <el-col :span="8">
        <!-- <div>
          <el-button type="primary">发布横幅</el-button>
        </div> -->
      </el-col>
      <el-col :span="16">
        <div style="float: right">
          <el-pagination
            :hide-on-single-page="false"
            v-model:page-size="queryParam.pageSize"
            :page-sizes="[10, 15, 20, 30]"
            :background="true"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="changeChangeSize"
            @current-change="changePage"
          />
        </div>
      </el-col>
    </el-row>
  
    <el-drawer
      ref="drawerRef"
      v-model="dialog"
      :title="title"
      direction="rtl"
      :close-on-click-modal="false"
      size="60%"
      @close="doBannerClose()"
    >
      <div class="common-drawer__content">
        <el-form
          ref="bannerFormRef"
          :model="bannerForm"
          :rules="rules"
          label-width="120px"
        >
        <el-form-item label="类型" prop="btype">
          <el-select
            style="width:100%"
            v-model="bannerForm.btype"
            clearable
            placeholder="请选择类型"
          >
            <el-option
              v-for="item in bannerTypeData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
            <el-input
              v-model.trim="bannerForm.title"
              placeholder="请输入标题"
            ></el-input>
          </el-form-item>
          <el-form-item label="图" prop="picture">
            <el-upload
              class="upload-demo"
              action="/api/upload/common"
              :auto-upload="true"
              ref="fileUpload1"
              :headers="headerUpload"
              :on-success="doUploadSuccess"
              :before-upload="beforeUpload"
              accept="image/png, image/jpeg, image/jpg"
              name="picture"
            >
            <template #trigger>
              <el-button type="primary">选择图片</el-button>
            </template>
             
              <template #tip>
                <div class="el-upload__tip">
                  请上传Png、Jpeg、Jpg后缀名且小于1M的文件。
                </div>
              </template>
            </el-upload>
            <el-image v-if="bannerForm.picture" style="width: 120px;display: block;" :src="bannerForm.picture" />
          </el-form-item>
          <el-form-item label="页面" prop="page">
            <el-input
              v-model.trim="bannerForm.page"
              placeholder="请输入页面"
            ></el-input>
          </el-form-item>
          <el-form-item label="权重" prop="weight">
            <el-input
              v-model.trim="bannerForm.weight"
              placeholder="请输入权重"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-radio-group v-model="bannerForm.status">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="2">停用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div class="common-drawer__footer">
          <el-button @click="doBannerClose()">关闭</el-button>
          <el-button type="primary" :loading="loading" @click="doBannerSave">{{
            loading ? "提交中 ..." : "提交"
          }}</el-button>
        </div>
      </div>
    </el-drawer>
  </template>
  
  <script setup>
  import { ref, onMounted } from "vue";
  // import { useRouter } from "vue-router";
  import { ElDrawer, ElTable, ElMessage } from "element-plus";
  import { listBanner, deleteBanner,saveBanner  } from "@/api/banner";
    
  import util from "@/util/tool.js";
  // import storage from "@/util/storage.js";
  
  import store from "@/store";

  import config from "@/util/config.js";

  
  let timer;
  
  const dialog = ref(false);
  const loading = ref(false);
  const loadingData = ref(true);
  
  const bannerTypeData = config.configBannerTypeData;

  
  // const router = useRouter();
  // let open = (routeName, row) => {
  //   storage.saveSessionObject("bannerPath",queryParam.value)
  //   router.push({
  //     name: routeName,
  //     params: { id: row.bannerid },
  //     query: { eflag:row.eflag, name: row.name },
  //   });
  // };
  
  const drawerRef = ref(ElDrawer);
  
  const tableData = ref();
  const total = ref(0);
  const pageSize = ref(15); //每页显示条数
  
  let bannerFormRef = ref();
  let title = ref("发布横幅");
  
  // const defaultSelectDepart = ref([])
  
  //onMounted方法
  onMounted(() => {
    getListBanner();
  });
  
  
  //搜索查询
  const queryParam = ref({
    pageNo: 1,
    pageSize: pageSize.value,
    btype:"",
    status: "",
    title: "",
  });
  const resetSearch = () => {
    queryParam.value = {
      pageNo: 1,
      pageSize: pageSize.value,
      btype: "",
      status: "",
      title: "",
    };
    getListBanner();
  };
  
  //横幅表单项
  let bannerForm = ref({
    bannerid: null,
    btype: "",
    title: "",
    picture: "",
    page: "",
    weight: "",
    status: 1,
  });
  
  //发布横幅
  const doBannerAdd = () => {
    title.value = "发布横幅";
    // console.log('add',bannerForm.value)
  
    // bannerForm.value.content = ''
    // editorRef.value.valueHtml = '<p></p>'
    resetForm();
  };
  
  //编辑横幅
  const doBannerEdit = (index, obj) => {
    title.value = "编辑横幅";
  
    bannerForm.value = {
      bannerid: obj.bannerid,
      btype: obj.btype,
      title: obj.title,
      picture: obj.picture,
      page: obj.page,
      weight: obj.weight,
      status: obj.status,
    };
  
  };
  const resetForm = () => {
    bannerForm.value = {
      bannerid: null,
      btype: "",
      title: "",
      picture: "",
      page: "",
      weight: "",
      status:1,
    };
  };
  
  //关闭横幅表单弹窗
  const doBannerClose = () => {
    loading.value = false;
    dialog.value = false;
    clearTimeout(timer);
    bannerFormRef.value.resetFields()
  };
  
  //保存横幅数据
  const doBannerSave = () => {
    bannerFormRef.value.validate((valid) => {
      if (!valid) {
        //ElMessage("请先完善表单数据填写！");
        return;
      }
      saveBanner(bannerForm.value).then((res) => {
        loading.value = true;
        timer = setTimeout(() => {
          // 动画关闭需要一定的时间
          setTimeout(() => {
            loading.value = false;
          }, 400);
          if (res.data.code === 1) {
            getListBanner();
            doBannerClose();
          } else {
            ElMessage.error(res.data.msg);
          }
        }, 1000);
      });
    });
  };
  
  //更新横幅状态
  const doBannerDelete = (index, obj) => {
    // console.log('obj.bannerid',obj.bannerid.toString())
    deleteBanner(obj).then((res) => {
      // console.log(res);
      if (res.data.code === 1) {
        getListBanner();
      } else {
        ElMessage.error(res.data.msg);
      }
    });
  };
  
  //分页
  const changePage = (current) => {
    queryParam.value.pageNo = current;
    getListBanner();
  };
  const changeChangeSize = (size) => {
    pageSize.value = size;
    queryParam.value.pageSize = size;
    getListBanner();
  };
  
  //横幅列表API
  const getListBanner = () => {
    listBanner(queryParam.value).then((res) => {
      tableData.value = res.data.extend.pages.list;
      total.value = res.data.extend.pages.total;
      queryParam.value.pageSize = pageSize.value;
      loadingData.value = false
    });
  };
  
  //横幅表单验证规则
  const rules = ref({
    btype: [
      {
        required: true,
        message: "请选择横幅类型",
        trigger: "blur",
      },
    ],
    picture: [
      {
        required: true,
        message: "请上传横幅图",
        trigger: "blur",
      },
    ],
    title: [
      {
        required: true,
        message: "请输入标题",
        trigger: "blur",
      },
      {
        min: 2,
        max: 200,
        message: "标题长度2到200",
        trigger: "blur",
      },
    ],
  });
  
  
  const filefail = ref("");
  const resultMsg = ref();
  const fileUpload1 = ref();
  const doUploadSuccess = (response) => {  
    if (response.code === 0) {    
      ElMessage.error(response.msg)
    } else {
      resultMsg.value = response.msg
      filefail.value = response.url
      bannerForm.value.picture = response.url
      setTimeout(function(){
        fileUpload1.value.clearFiles()
      },1000)
    }
  };
  const beforeUpload = (rawFile) => {
    if (rawFile.type !== 'image/png' && rawFile.type !=='image/jpeg' && rawFile.type !=='image/jpg') {
      ElMessage.error('请上传PNG、JPEG、JPG格式图片!')
      return false
    } else if (rawFile.size / 1024 / 1024 > 1) {
      ElMessage.error('请上传小于1MB的文件!')
      return false
    }
    resultMsg.value = '正在上传处理中，请勿关闭或跳转页面！'
    return true
  }
  
  const headerUpload = ref({
    Authorization: store.state.user.token,
  })
  </script>
  